import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Breadcrumbs from '../../layout/Breadcrumbs';

// Example CSS (Optional): You can create your own About.css and import it here
// import './About.css';

const About = ({ showBreadcrumbs = true }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize AOS library
    AOS.init({
      duration: 800, // Animation duration in ms
      offset: 100,   // Offset (in px) from the original trigger point
      once: true,    // Whether animation should happen only once - while scrolling down
    });
  }, []);

  return (
    <>
      {/* Conditionally render Breadcrumbs */}
      {showBreadcrumbs && (
        <Breadcrumbs
          pageTitle="About Us"
          activePage="About Us"
        />
      )}

      {/* ===================== INTRO SECTION ===================== */}
      <section id="about-us" className="about-info">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* TEXT */}
            <div className="col-lg-6" data-aos="fade-left">
              <small className="mb-2 text-danger">Welcome to BBSoft & Spadez</small>
              <h2 className="mb-2">Empowering your digital future with global talent and local trust.</h2>
              <p>
                BBSoft is a Canadian technology company with a global outlook. We specialize in delivering powerful, efficient, and 
                scalable software solutions across various industries. Through our offshore development center, Spadez Technologies, located in India, 
                we offer our clients the perfect combination of North American quality and Indian development agility.
              </p>
              <p>
                We don’t just build software — we solve business challenges, enable growth, and create measurable impact.
              </p>
              <h3>Trusted by Businesses Worldwide</h3>
              <p>Our clients span across Canada, the US, Europe, and Australia from startups to enterprises. Whether you're looking for a technology partner to build your next 
                platform or seeking to optimize internal operations through automation, BBSoft delivers results, backed by a proven offshore model.
              </p>

              <h3>Industries We Serve</h3>
              
              <ul className="list-unstyled services-list">
                <li>Healthcare</li>
                <li>Finance & FinTech</li>
                <li>Logistics & Transportation</li>
                <li>Education & eLearning</li>
                <li>Retail & E-Commerce</li>
                <li>Government & Public Services</li>
              </ul> 
              <button className="btn btn-md btn-outline-danger mt-3" onClick={() => navigate("/services")} >
                 View Solutions
              </button>
             
            </div>
            {/* IMAGE */}
            <div className="col-lg-6 service-development" data-aos="fade-right">
                <div className="row mt-2 gap-md-2">
                  {/* Our Approach Card */}
                  <div className="bg-white rounded-xl shadow overflow-hidden col-12 col-md-5 col-sm-6 mb-3">
                    <img src="./assets/images/services/our-approach.png" alt="Our Approach" className="img-fluid" />
                    <div className="p-6">
                      <h5 className="text-xl font-semibold text-gray-800">Our Approach</h5>
                      <p className="mt-1 text-gray-600">
                        We believe in a client-first strategy, ensuring each project is aligned with business goals while delivering top-notch quality and efficiency.
                      </p>
                    </div>
                  </div>

                  {/* Development Strategy Card */}
                  <div className="bg-white rounded-xl shadow overflow-hidden col-12 col-md-6 col-sm-6 mb-3">
                    <img src="./assets/images/services/development-strategy.png" alt="Development Strategy" className="img-fluid" />
                    <div className="p-6">
                      <h5 className="text-xl font-semibold text-gray-800">Development Strategy</h5>
                      <p className="mt-1 text-gray-600">
                        Our agile methodology ensures flexibility, continuous improvements, and seamless collaboration throughout the development process.
                      </p>
                    </div>
                  </div>

                  {/* Client Feedback Card */}
                  <div className="bg-white rounded-xl shadow overflow-hidden col-12 col-md-6 col-sm-6 mb-3">
                    <img src="./assets/images/services/client-feedback.png" className="img-fluid" alt="Client Feedback" />
                    <div className="p-6">
                      <h5 className="text-xl font-semibold text-gray-800">Client Feedback</h5>
                      <p className="mt-1 text-gray-600">
                        We value our clients' opinions and continuously refine our services based on their feedback, ensuring the best possible outcomes.
                      </p>
                    </div>
                  </div>

                  {/* Our Workflow Card */}
                  <div className="bg-white rounded-xl shadow overflow-hidden col-12 col-md-5 col-sm-6 mb-3">
                    <img src="./assets/images/services/our-workflow.png" alt="Our Workflow" className="img-fluid" />
                    <div className="p-6">
                      <h5 className="text-xl font-semibold text-gray-800">Our Workflow</h5>
                      <p className="mt-1 text-gray-600">
                        A structured workflow allows us to maintain clarity, efficiency, and consistency, ensuring that every project runs smoothly from start to finish.
                      </p>
                    </div>
                  </div>

                
                </div>
              </div>

          </div>
          


        </div>
      </section>
    </>
  );
};

export default About;
